module.exports = __webpack_public_path__ + "static/media/2.8e89125d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/reviews/2.png
// module id = 1722
// module chunks = 0